  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const hasCustomerPosted = urlParams.get('customer_posted') === 'true';
    const hash = window.location.hash;
 
    if (hasCustomerPosted && hash != "" ) {
      function tryTriggerClick() {
        const triggerBtn = document.querySelector('.js-open-download-modal');
        if (!triggerBtn) {
          return setTimeout(tryTriggerClick, 100); 
        }
        triggerBtn.click();
      }

      tryTriggerClick();
    }
  });
